import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_INVOICE_INSTITUTIONS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  BillingInstitutions,
  GetPublicInvoiceInstitutionsPayload,
  GetPublicInvoiceInstitutionsResult,
} from '../types/getBillingInstitutions.types';

export const getPublicInvoiceInstitutions = (builder: BuilderType) =>
  builder.query<BillingInstitutions[], GetPublicInvoiceInstitutionsPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_INVOICE_INSTITUTIONS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPublicInvoiceInstitutionsResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.BillingInstitutions;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
